import React, { useState } from 'react'

import {
  GoogleParamsDescription,
  GoogleParamsTabStyled,
  GoogleParamsYouHaveUtm,
  Link,
} from 'Features/CheqParamsModal/Tabs/Google/GoogleParamsTab.styled'
import {
  OutsideLink,
  RadioButtonGroup,
  StyledText,
  InfoCircled,
  Tooltip,
} from '@clickcease/cc-client-components-lib'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useGetPlatforms } from 'Features/domainsManagement/api/getPlatforms'
import { UTMParameters } from './UTMParameters'
import { MetaParamsNotice, MetaParamsText } from '../Meta/MetaParamsTab.styled'

const learnMoreUrl = 'https://support.google.com/google-ads/answer/9054021?hl=en'

export const NewGoogleParamsTab = ({ closeModal }: { closeModal: () => void }) => {
  const { t } = useTranslation('domainManagement')
  const { data: platforms } = useGetPlatforms({})
  const navigate = useNavigate()
  const googlePlatform =
    platforms && platforms.find((platform) => platform.platformType === 'Google')
  const isGoogleConnected = googlePlatform && googlePlatform.connectionStatus === 'Connected'

  const [haveUtm, setHaveUtm] = useState<string>('dontHave')
  const options = [
    {
      value: 'dontHave',
      label: t('tracking_params_modal.google_tab.i_dont_use_utm'),
    },
    {
      value: 'have',
      label: t('tracking_params_modal.google_tab.i_use_utm'),
    },
  ]

  const goToPlatforms = () => {
    navigate('/paid-marketing/platforms')
    closeModal()
  }

  return (
    <GoogleParamsTabStyled>
      {!isGoogleConnected && (
        <MetaParamsNotice>
          <InfoCircled />
          <MetaParamsText>
            <Trans
              ns={'domainManagement'}
              i18nKey={'tracking_params_modal.google_tab.no_google_connections'}
              components={{
                1: <Link onClick={goToPlatforms} />,
              }}
            />
          </MetaParamsText>
        </MetaParamsNotice>
      )}
      <GoogleParamsDescription>
        <Trans ns="domainManagement" i18nKey="tracking_params_modal.google_tab.description_1" />
        <br />
        <Trans
          ns="domainManagement"
          i18nKey="tracking_params_modal.google_tab.description_2"
          components={{ 1: <OutsideLink target={'_blank'} href={learnMoreUrl} /> }}
        />
      </GoogleParamsDescription>
      <GoogleParamsYouHaveUtm>
        <StyledText variant={'baseBold'}>
          {t('tracking_params_modal.google_tab.do_you_use_utm')}
        </StyledText>
        <Tooltip
          trigerStyle={{
            style: {
              color: 'var(--colors-neutral)',
              marginLeft: '8px',
              display: 'flex',
              alignItems: 'center',
            },
          }}
          tooltiptContent={t('tracking_params_modal.google_tab.description_3')}
        />
      </GoogleParamsYouHaveUtm>
      <RadioButtonGroup
        row
        options={options}
        selectedValue={haveUtm}
        onChange={(value: string) => {
          setHaveUtm(value)
        }}
      />
      <UTMParameters haveUtm={haveUtm === 'have'} />
    </GoogleParamsTabStyled>
  )
}
